export const orderCountries = countries =>
  countries.sort(function (a, b) {
    if (a.code === 'ES') return -1
    const countryA = a.name.toUpperCase()
    const countryB = b.name.toUpperCase()
    return countryA < countryB ? -1 : countryA > countryB ? 1 : 0
  })
